"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper.js");
var _OrderWarningModalComponent = _interopRequireDefault(require("../../../ConfirmOrderModal/OrderWarningModalComponent.js"));
var _index = _interopRequireDefault(require("../../../ConfirmOrderModal/index.js"));
var _APReactSelect = _interopRequireDefault(require("../../../common/APReactSelect/APReactSelect"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon/APIcon.js"));
var _Button = require("../../../form/Button/Button.js");
var _VerificationRequiredContainer = _interopRequireDefault(require("../../../VerificationRequired/VerificationRequiredContainer.js"));
var _FuturesOrderEntryEstimates = require("../FuturesOrderEntryEstimates/FuturesOrderEntryEstimates.js");
var _FuturesFormAmountFields = require("../FuturesFormAmountFields.js");
require("../../../../styles/components/TradeComponent.css");
require("./FuturesOrderEntry.css");
var _FuturesPnLCalculatorModal = _interopRequireDefault(require("../FuturesPnLCalculator/FuturesPnLCalculatorModal.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var orderEntryClasses = (0, _cssClassesHelper.getBEMClasses)('order-entry');
var futuresOrderEntryClasses = (0, _cssClassesHelper.getBEMClasses)('futures-order-entry');
var FuturesOrderEntryAnchoringComponent = function FuturesOrderEntryAnchoringComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    futuresOrderTypesOptions = props.futuresOrderTypesOptions,
    title = props.title,
    reduxFormChange = props.reduxFormChange,
    leverage = props.leverage,
    maxQuantity = props.maxQuantity,
    form = props.form,
    openPnLCalculator = props.openPnLCalculator,
    fetchMaxQuantity = props.fetchMaxQuantity,
    instrumentId = props.instrumentId,
    invalid = props.invalid;
  (0, _react.useEffect)(function () {
    if (instrumentId) {
      fetchMaxQuantity(instrumentId, leverage);
    }
  }, [fetchMaxQuantity, instrumentId, leverage]);
  var resetState = (0, _react.useCallback)(function () {
    reduxFormChange('limitPrice', '');
    reduxFormChange('stopPrice', '');
    reduxFormChange('value', '');
    reduxFormChange('quantity', '');
  }, [reduxFormChange]);
  var orderTypeOptions = (0, _react.useMemo)(function () {
    return futuresOrderTypesOptions.map(function (_ref) {
      var label = _ref.label,
        value = _ref.value;
      return {
        label: t(label),
        value: value
      };
    });
  }, [futuresOrderTypesOptions, t]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(orderEntryClasses(), futuresOrderEntryClasses())
  }, title || null, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: orderEntryClasses('form')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: futuresOrderEntryClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: futuresOrderEntryClasses('order-type-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
    name: "orderType",
    label: t('Order Type'),
    customClass: futuresOrderEntryClasses('order-type-select'),
    onChange: resetState,
    isSearchable: false,
    valueAsObject: false,
    options: orderTypeOptions,
    showTriangles: true
  }), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: futuresOrderEntryClasses('calculator-button'),
    variant: "secondary",
    type: "button",
    iconOnly: true,
    onClick: openPnLCalculator
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "calculator"
  }))), /*#__PURE__*/_react["default"].createElement(_FuturesFormAmountFields.FuturesFormAmountFields, {
    baseClasses: orderEntryClasses,
    futuresOrderEntryClasses: futuresOrderEntryClasses,
    formName: form,
    maxQuantity: maxQuantity
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: futuresOrderEntryClasses('futures-order-entry-estimates')
  }, /*#__PURE__*/_react["default"].createElement(_FuturesOrderEntryEstimates.FuturesOrderEntryEstimates, {
    baseClass: futuresOrderEntryClasses(),
    formName: form
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(futuresOrderEntryClasses(), 'futures-submit-buttons-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    type: "submit",
    onClick: function onClick() {
      return reduxFormChange('side', '0');
    },
    variant: "success",
    disabled: submitting || invalid
  }, submitting ? t('Processing...') : t('Long')), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    type: "submit",
    onClick: function onClick() {
      return reduxFormChange('side', '1');
    },
    variant: "danger",
    disabled: submitting || invalid
  }, submitting ? t('Processing...') : t('Short'))), /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], null))), /*#__PURE__*/_react["default"].createElement(_OrderWarningModalComponent["default"], null), /*#__PURE__*/_react["default"].createElement(_index["default"], null), /*#__PURE__*/_react["default"].createElement(_FuturesPnLCalculatorModal["default"], null));
};
FuturesOrderEntryAnchoringComponent.defaultProps = {
  submitting: false
};
FuturesOrderEntryAnchoringComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  orderEntryForm: _propTypes["default"].object.isRequired,
  submitting: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool.isRequired,
  disableTrading: _propTypes["default"].bool.isRequired,
  VerificationRequiredComponent: _propTypes["default"].element,
  side: _propTypes["default"].string.isRequired,
  isBuy: _propTypes["default"].bool.isRequired,
  maxQuantity: _propTypes["default"].number.isRequired,
  openPnLCalculator: _propTypes["default"].func.isRequired,
  fetchMaxQuantity: _propTypes["default"].func.isRequired,
  instrumentId: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = FuturesOrderEntryAnchoringComponent;